import { configureStore } from "@reduxjs/toolkit";

import filterReducer from "@/feature/filter/filterSlice";

export const store = configureStore({
  reducer: {
    filters: filterReducer, // ✅ Filter-Reducer für Filterzustand
  },
});

export default store;
